/**
 * El color de cada canal, una vez.
 *
 * Un canal no tiene un color de diseno: tiene **el suyo**, el de la marca, y
 * por eso es la excepcion declarada del estandar. Estaba inventado dos veces
 * -`components/brain/presentation.ts` pintaba WhatsApp de `emerald-500` y
 * `conversations/platform-filters.tsx` del verde de verdad, `#25D366`- y dos
 * verdes distintos para la misma marca no son un matiz: son un error que nadie
 * ve porque las dos pantallas no se miran juntas.
 *
 * Lo que NO va aqui: un estado (`success`, `warning`), una jerarquia
 * (`primary`) ni nada que deba cambiar con el tema. Eso son tokens.
 */
/* eslint-disable no-restricted-syntax -- el color de un canal es el de su marca: no es un estilo que podamos elegir */

/** Los hex oficiales. Se escriben como hex a proposito: una marca no se */
/** aproxima con la paleta de Tailwind, se copia. */
export const COLOR_DE_CANAL = {
  whatsapp: '#25D366',
  instagram: '#E4405F',
  facebook: '#1877F2',
  messenger: '#0084FF',
  betterplace: '#C56B1A',
  wordpress: '#21759B',
  email: '#EA4335',
  shopify: '#7AB55C',
  twitter: '#1DA1F2',
  /** La llamada no es una marca, pero es un canal y necesita distinguirse.
   *  Estaba escrita con dos verdes distintos -#22C55E y #10B981- en dos
   *  ficheros que pintan la misma llamada. */
  phone_call: '#22C55E',
} as const

/**
 * Instagram no tiene un color, tiene un degradado, y es el unico. Los tres
 * puntos van aqui para que no se copien al siguiente sitio que lo pinte.
 */
export const DEGRADADO_DE_INSTAGRAM = ['#F58529', '#DD2A7B', '#8134AF'] as const

/**
 * Lo que NO es una marca, y llevaba color de marca por inercia: «web» iba con
 * el azul de LinkedIn y el avatar con un violeta suelto. Los dos son piezas de
 * este producto, asi que los dos son `primary`.
 */
export const CANALES_SIN_MARCA = ['web', 'avatar', 'other'] as const

export type ClaveDeCanal = keyof typeof COLOR_DE_CANAL

/** Para `className`: Tailwind no genera clases a partir de una variable, asi */
/** que el color de marca viaja en `style`, no en una clase. */
export const estiloDeCanal = (canal: ClaveDeCanal) => ({ color: COLOR_DE_CANAL[canal] })

/**
 * Las categorias de contacto. No son estados -un proveedor no es «peor» que un
 * cliente-, son cinco etiquetas que hay que poder distinguir de un vistazo, y
 * por eso son dato y no token. El colaborador lleva `primary` porque es el
 * caso por defecto de este producto.
 */
export const COLOR_DE_CATEGORIA = {
  lead: { color: 'text-amber-500', fondo: 'bg-amber-500/10' },
  client: { color: 'text-emerald-500', fondo: 'bg-emerald-500/10' },
  vendor: { color: 'text-purple-500', fondo: 'bg-purple-500/10' },
  collaborator: { color: 'text-primary', fondo: 'bg-primary/10' },
  employee: { color: 'text-rose-500', fondo: 'bg-rose-500/10' },
} as const
